export const selectCurrentTenant = (state) => state.shared.currentTenant;
export const selectCurrentTenantId = (state) => state.shared.currentTenant?.id;
export const selectAllTenantsLoading = (state) => state.shared.allTenantsLoading;
export const selectAllTenants = (state) => state.shared.allTenants;
